import styled from 'styled-components';

import { black, chartLightGray, hoverGreen } from 'styles/colors';
import { rgba } from 'polished';

const PADDING = '30px';
const PAGE_TOOLBAR_HEIGHT = '64px';

export const Header = styled.header`
	height: ${PAGE_TOOLBAR_HEIGHT};
	padding: 0 ${PADDING};
	font-size: 19px;
	font-weight: bold;
	letter-spacing: 0.8px;
	border-bottom: 1px solid ${rgba('#000', 0.09)};
	display: flex;
	align-items: center;
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
`;

export const Body = styled.div`
	margin-top: 60px;
	margin-bottom: 2px;

	& div[data-tooltipped] {
		position: relative;
		top: 12px;
	}
`;

export const CloseIcon = styled.div`
	cursor: pointer;
	position: absolute;
	right: 23px;
	top: 20px;
`;

export const CorrelationId = styled.span`
	font-size: 13px;
	font-family: 'PT Mono';
	letter-spacing: 0.8px;
	line-height: 24px;
	color: ${hoverGreen};
	border: 1px solid ${hoverGreen};
	background-color: ${chartLightGray};
	padding: 4px 8px;
	word-wrap: break-word;
	display: inline-block;
	width: 100%;
	cursor: default;
`;

export const Label = styled.div`
	color: ${black};
	font-size: 16px;
	font-weight: bold;
	letter-spacing: 0.3px;
	line-height: 24px;
	margin-top: 18px;
	margin-bottom: -16px;
`;

export const TooltipPosition = styled.span`
	width: 100%;
	display: inline-block;
	position: relative;
	height: 1px;
`;

export const DemoModeInfo = styled.div`
	margin-top: 32px;
`;
